"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const rxjs_1 = require("rxjs");
const hw_app_str_1 = __importDefault(require("@ledgerhq/hw-app-str"));
const errors_1 = require("@ledgerhq/errors");
const deviceAccess_1 = require("../../hw/deviceAccess");
const js_buildTransaction_1 = require("./js-buildTransaction");
const api_1 = require("./api");
const logic_1 = require("./logic");
const buildOptimisticOperation = (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const transactionSequenceNumber = yield (0, api_1.fetchSequence)(account);
    const fees = (_a = transaction.fees) !== null && _a !== void 0 ? _a : new bignumber_js_1.BigNumber(0);
    const type = transaction.mode === "changeTrust" ? "OPT_IN" : "OUT";
    const operation = {
        id: `${account.id}--${type}`,
        hash: "",
        type,
        value: transaction.subAccountId ? fees : (0, logic_1.getAmountValue)(account, transaction, fees),
        fee: fees,
        blockHash: null,
        blockHeight: null,
        senders: [account.freshAddress],
        recipients: [transaction.recipient],
        accountId: account.id,
        date: new Date(),
        // FIXME: Javascript number may be not precise enough
        transactionSequenceNumber: transactionSequenceNumber === null || transactionSequenceNumber === void 0 ? void 0 : transactionSequenceNumber.plus(1).toNumber(),
        extra: {},
    };
    const { subAccountId } = transaction;
    const { subAccounts } = account;
    const tokenAccount = !subAccountId
        ? null
        : subAccounts && subAccounts.find(ta => ta.id === subAccountId);
    if (tokenAccount && subAccountId) {
        operation.subOperations = [
            {
                id: `${subAccountId}--OUT`,
                hash: "",
                type: "OUT",
                value: transaction.useAllAmount ? tokenAccount.balance : transaction.amount,
                fee: new bignumber_js_1.BigNumber(0),
                blockHash: null,
                blockHeight: null,
                senders: [account.freshAddress],
                recipients: [transaction.recipient],
                accountId: subAccountId,
                date: new Date(),
                extra: {},
            },
        ];
    }
    return operation;
});
/**
 * Sign Transaction with Ledger hardware
 */
const signOperation = ({ account, deviceId, transaction, }) => (0, deviceAccess_1.withDevice)(deviceId)(transport => rxjs_1.Observable.create(o => {
    function main() {
        return __awaiter(this, void 0, void 0, function* () {
            o.next({
                type: "device-signature-requested",
            });
            // Fees are loaded during prepareTransaction
            if (!transaction.fees) {
                throw new errors_1.FeeNotLoaded();
            }
            const unsigned = yield (0, js_buildTransaction_1.buildTransaction)(account, transaction);
            const unsignedPayload = unsigned.signatureBase();
            // Sign by device
            const hwApp = new hw_app_str_1.default(transport);
            const { signature } = yield hwApp.signTransaction(account.freshAddressPath, unsignedPayload);
            unsigned.addSignature(account.freshAddress, signature.toString("base64"));
            o.next({
                type: "device-signature-granted",
            });
            const operation = yield buildOptimisticOperation(account, transaction);
            o.next({
                type: "signed",
                signedOperation: {
                    operation,
                    signature: unsigned.toXDR(),
                    expirationDate: null,
                },
            });
        });
    }
    main().then(() => o.complete(), e => o.error(e));
}));
exports.default = signOperation;
//# sourceMappingURL=js-signOperation.js.map